(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_header"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=()=>{
  const header=document.getElementById('CustomStickyHeader');
  if(!header||header.dataset.initialized)return;
  header.dataset.initialized='true';
  const content=header.querySelector('.custom-sticky-header__content');
  const toggle=header.querySelector('#StickyNavToggle');
  const drawer=header.querySelector('#StickyNavDrawer');
  const wrapper=document.querySelector('.page-wrapper');
  const syncHeight=()=>document.documentElement.style.setProperty('--tcg-header-height',content.getBoundingClientRect().height+'px');
  syncHeight();if('ResizeObserver' in window)new ResizeObserver(syncHeight).observe(content);
  const onScroll=()=>header.classList.toggle('is-scrolled',Math.max(window.scrollY,wrapper?.scrollTop||0)>100);
  window.addEventListener('scroll',onScroll,{passive:true});wrapper?.addEventListener('scroll',onScroll,{passive:true});onScroll();
  let savedRoot='',savedWrapper='';
  const setOpen=(open)=>{
   const previous=toggle.getAttribute('aria-expanded')==='true';
   if(previous===open)return;
   toggle.setAttribute('aria-expanded',String(open));drawer.inert=!open;drawer.classList.toggle('is-open',open);header.classList.toggle('is-open',open);
   if(open){savedRoot=document.documentElement.style.overflow;savedWrapper=wrapper?.style.overflow||'';document.documentElement.style.overflow='hidden';if(wrapper)wrapper.style.overflow='hidden';requestAnimationFrame(()=>drawer.querySelector('a')?.focus());}
   else{document.documentElement.style.overflow=savedRoot;if(wrapper)wrapper.style.overflow=savedWrapper;toggle.focus();}
  };
  toggle.addEventListener('click',()=>setOpen(toggle.getAttribute('aria-expanded')!=='true'));
  drawer.addEventListener('click',e=>{if(e.target.closest('a'))setOpen(false)});
  header.addEventListener('keydown',e=>{
   if(toggle.getAttribute('aria-expanded')!=='true')return;
   if(e.key==='Escape'){e.preventDefault();setOpen(false);return;}
   if(e.key==='Tab'){
    const nodes=[toggle,...drawer.querySelectorAll('a[href],button')];const current=nodes.indexOf(document.activeElement);
    e.preventDefault();nodes[(current+(e.shiftKey?-1:1)+nodes.length)%nodes.length]?.focus();
   }
  });
 };
 init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcg-random-feature"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-tcg-pick]').forEach((section) => {
      if(section.dataset.ready) return;
      section.dataset.ready = 'true';
      const count = Math.min(Number(section.dataset.count),25000);
      if(!count || !section.dataset.poolUrl) return;
      const run = async () => {
        for(let attempt=0;attempt<3;attempt++) {
          try {
            const url = new URL(section.dataset.poolUrl,location.origin);
            url.searchParams.set('view','tcg-featured');
            url.searchParams.set('page',String(Math.floor(Math.random()*count)+1));
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if(preview) url.searchParams.set('preview_theme_id',preview);
            const response = await fetch(url,{signal:AbortSignal.timeout(10000)});
            if(!response.ok) continue;
            const doc = new DOMParser().parseFromString(await response.text(),'text/html');
            const card = doc.querySelector('.tcg-pick__card');
            if(card){section.querySelector('[data-pick-content]').replaceChildren(document.importNode(card,true));return;}
          } catch(error) { return; }
        }
      };
      if('IntersectionObserver' in window){const observer=new IntersectionObserver((entries)=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();run();}},{rootMargin:'400px'});observer.observe(section);}else{run();}
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
